<template>
  <div class="NativeAppDownloadWidget bg-white column">
    <label class="fw-med fc-mid fs-14 mb-8 no-select no-wrap">
      MOBILE APP IS AVAILABLE!
    </label>
    <a
      href="https://play.google.com/store/apps/details?id=com.bobtail.app&hl=en_US&gl=US"
      target="_blank"
    >
      <img
        alt="Download app for free on Google Play"
        class="NativeAppDownloadWidget__app-store-image"
        src="../assets/google-play-badge.svg"
      >
    </a>
    <a
      href="https://apps.apple.com/app/apple-store/id6443498223"
      target="_blank"
    >
      <img
        alt="Download app for free on Apple Store"
        class="NativeAppDownloadWidget__app-store-image"
        src="../assets/applestore--black.svg"
      >
    </a>
  </div>
</template>

<script>
export default {
  name: 'NativeAppDownloadWidget',
}
</script>

<style lang="sass">
.NativeAppDownloadWidget
  border: $border
  border-radius: $border-radius
  margin-top: rem(56px)
  padding: rem(17px)

  .fa
    margin-right: rem(8px)

  .fa-user
    font-size: rem(19px)

  .fa-mail
    font-size: rem(14px)

  .fs-phone
    font-size: rem(18px)

  &__app-store-image
    width: rem(150px)
</style>
